var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { ComposedChart as RechartsComposedChart, ResponsiveContainer } from 'recharts';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { AreaChart } from '../area-chart/area-chart.js';
import { renderAreas, renderBars, renderLines } from '../axis-chart/axis-chart-utils.js';
import { AxisChart } from '../axis-chart/axis-chart.js';
import { BarChart } from '../bar-chart/bar-chart.js';
import { ChartClickType, ChartType } from '../base-chart/base-chart-constants.js';
import { LineChart } from '../line-chart/line-chart.js';
import { ComposedChartAPI } from './composed-chart-api.js';
let ComposedChart = class ComposedChart extends AxisChart {
    constructor() {
        super(...arguments);
        this.state = {
            ...AreaChart.defaultState,
            ...BarChart.defaultState,
            ...LineChart.defaultState,
        };
        this.onComposedChartClick = (item) => {
            this.onClick({ item, type: ChartClickType.CHART });
        };
    }
    render() {
        const { activeDot, areas, bars, data, dot, height: rawHeight, lines, layout, margin, minHeight, minWidth, syncId, width: rawWidth, } = this.props;
        const noCartesianComponents = !areas.length && !bars.length && !lines.length;
        if (!data.length || noCartesianComponents) {
            return null;
        }
        const { hiddenLegends } = this.state;
        const sizes = this.getChartSizes(rawHeight, rawWidth);
        if (!sizes.length) {
            throw new Error('[Composed Chart]: One of the props width and height must be a percentage string.');
        }
        const [height, width] = sizes;
        const areasOptions = {
            activeDot,
            areas,
            dot,
            hiddenLegends,
            onClick: this.onClick,
            onDynamicContentRender: this.onDynamicContentRender,
        };
        const barsOptions = {
            bars,
            hiddenLegends,
            onClick: this.onClick,
        };
        const linesOptions = {
            activeDot,
            dot,
            hiddenLegends,
            lines,
            onClick: this.onClick,
            onDynamicContentRender: this.onDynamicContentRender,
        };
        return (React.createElement(ResponsiveContainer, { height: height, minHeight: minHeight, minWidth: minWidth, width: width },
            React.createElement(RechartsComposedChart, { className: this.getClassName(ChartType.COMPOSED), data: data, layout: layout, margin: margin, onClick: this.onComposedChartClick, syncId: syncId },
                this.renderBrush(),
                this.renderCartesianGrid(),
                this.renderXAxis(),
                this.renderYAxis(),
                renderAreas(areasOptions),
                renderBars(barsOptions),
                renderLines(linesOptions),
                this.renderTooltip(),
                this.renderLegends())));
    }
};
ComposedChart.propTypes = {
    ...AreaChart.propTypes,
    ...BarChart.propTypes,
    ...LineChart.propTypes,
};
ComposedChart.defaultProps = {
    ...AreaChart.defaultProps,
    ...BarChart.defaultProps,
    ...LineChart.defaultProps,
};
ComposedChart = __decorate([
    AwesomeComponent({ api: ComposedChartAPI, type: ComponentType.DATA_DISPLAY })
], ComposedChart);
export { ComposedChart, };
//# sourceMappingURL=composed-chart.js.map